export const LINKS_SIDEBAR = [
  {
    title: "Dashboard",
    href: "/dashboard",
    className:
      "pointer-events-none blur-[2px] flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/carte.png",
  },
  {
    title: "Actif",
    href: "/liste-actifs",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/batiment.png",
    showCount: true,
  },
];

export const NON_VIEWER_LINKS = [
  {
    title: "GexBox",
    href: "/gexbox",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/box.png",
    showFichier: true,
  },
  {
    title: "Classeurs",
    href: "/classeurs",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/reliures.png",
  },
];

export const MAITRE_ADMIN_LINKS = [
  {
    title: "Arborescence bâtimentaire",
    href: "/entité-géospatiale",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ordinateur-de-bureau.png",
    showCount: true,
  },
  {
    title: "Utilisateurs",
    href: "/utilisateurs",
    className:
      "pointer-events-none blur-[2px] flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ressources-humaines.png",
  },
];

export const GEXPERTISE_LINKS = [
 

  {
    bulles:"Accédez à votre documentation",
    title: "Actif",
    href: "/liste-actifs",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/batiment.png",
    showCount: true,
  },
  {
    bulles:"Déposez vos fichiers",
    title: "GexBox",
    href: "/gexbox",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/box.png",
    showCount: true,
  },
  {
    bulles:"Qualifiez vos fichiers",
    title: "Classeurs",
    href: "/classeurs",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/reliures.png",
    showCount: true,
  },
  {
    bulles:"Structurez vos actifs",
    title: "Arborescence bâtimentaire",
    href: "/entité-géospatiale",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ordinateur-de-bureau.png",
    showCount: true,
  },
  {
    bulles:"Structurez vos entité-foncière",
    title: "Délimitations foncières",
    href: "/entité-foncière",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ordinateur-de-bureau.png",
    showCount: true,
  },
  {
    bulles:"Extraction des données de Gexbox",
    title: "Extraction des données",
    href: "/rapport",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ordinateur-de-bureau.png",
    showCount: true,
  },
  {
    bulles:"Gérez vos environnements clients",
    title: "Environnement Client",
    href: "/environnement-client",
    className:
      " flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/idee-de-genie.png",
    showCount: true,
  },

];

export const CLIENT_LINKS = [


  {
    bulles:"Accédez à votre documentation",
    title: "Actif",
    href: "/liste-actifs",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/batiment.png",
    showCount: true,
  },
  {
    bulles:"Déposez vos fichiers",
    title: "GexBox",
    href: "/gexbox",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/box.png",
    showCount: true,
  },
  {
    bulles:"Qualifiez vos fichiers",
    title: "Classeurs",
    href: "/classeurs",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/reliures.png",
    showCount: true,
  },
  {
    bulles:"Structurez vos actifs",
    title: "Arborescence bâtimentaire",
    href: "/entité-géospatiale",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ordinateur-de-bureau.png",
    showCount: true,
  },
  {
    bulles:"Structurez vos entité-foncière",
    title: "Délimitations foncières",
    href: "/entité-foncière",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ordinateur-de-bureau.png",
    showCount: true,
  },

  {
    bulles:"Extraction des données de Gexbox",
    title: "Extraction des données",
    href: "/rapport",
    className:
      "flex items-center p-2 text-base font-normal text-gray-900 rounded-lg  hover:bg-gray-100 ",
    imgSrc: "/images/ordinateur-de-bureau.png",
    showCount: true,
  },
  
 
];
